export const getBookItemDetails = item => {
  return [
    item?.volumeInfo?.subtitle,
    new Date(item?.volumeInfo?.publishedDate)?.getFullYear(),
    (item?.volumeInfo?.authors ?? []).map(author => author).join(", "),
  ]
    .filter(it => it)
    .join(" · ");
};
